export default (component) => {
  const buttonSize = component.computed.buttonSize

  component.props.square = Boolean
  component.computed.buttonSize = function () {
    const klass = buttonSize.call(this)

    if (this.square) {
      return (klass || 'nosize') + (this.circle ? '' : ' is-circle') + ' is-square'
    } else {
      return klass
    }
  }
}
